import { Button, Result } from "antd";

/**
 * Noma'lum yo'l uchun 404 sahifasi.
 *
 * ⚠️⚠️ **BU KOMPONENT HECH QACHON NAVIGATSIYA QILMASLIGI KERAK.**
 *
 * Avval bu yerda `<Navigate to="/" replace />` turardi — «eskirgan xatcho'p
 * 404 ga tushmasin» degan niyat bilan. Natija teskari bo'lgan: har qanday
 * noma'lum URL brauzer tabini **crash** qilardi (`Maximum update depth
 * exceeded`). Brauzerda o'lchangan — staging'da ham, lokalda ham.
 *
 * Mexanizmi: `<Navigate>` navigatsiyani RENDER paytida boshlaydi, `RootRoute`
 * esa o'z `useEffect` idan `/login` ga yo'naltiradi. Ikkalasi bir-birining
 * kutilayotgan o'tishini bekor qiladi va HECH BIRI brauzer URL'iga commit
 * bo'lmaydi: `notFoundComponent` ichida `window.location.pathname` hamon eski
 * noma'lum yo'lda qolardi, router esa `/` ↔ `/login` orasida cheksiz
 * aylanardi. Sikl React'ning yangilanish chuqurligi chegarasiga urilib
 * tabni o'ldirardi.
 *
 * Shuning uchun bu yerda avtomatik yo'naltirish YO'Q va qaytarilmaydi —
 * foydalanuvchi tugmani O'ZI bosadi. Yagona navigator `RootRoute` bo'lib
 * qoladi, urishadigan ikkinchi tomon esa umuman yo'q.
 */
export function NotFoundRoute() {
	return (
		<div className="min-h-screen bg-[#f6f6f4] flex items-center justify-center p-6">
			<Result
				status="404"
				title="404"
				subTitle="Bunday sahifa topilmadi. Havola eskirgan yoki manzil noto'g'ri terilgan bo'lishi mumkin."
				extra={
					// ⚠️ TanStack `<Link>` EMAS, oddiy `<a>`: bu to'liq sahifa
					// yuklashini beradi va router'ning «topilmadi» holatini
					// butunlay tozalaydi. Klient tomonidagi o'tish esa aynan
					// yuqorida tasvirlangan urishni qaytarish yo'li bo'lardi.
					<Button type="primary" href="/">
						Bosh sahifaga
					</Button>
				}
			/>
		</div>
	);
}
